"use client";

import { c as _c } from "react/compiler-runtime";
import { getSubscriptionId,
// biome-ignore lint/style/noRestrictedImports: this is fine
useSubscription as useBaseSubscription } from "@opensea/graphql";
import { useCallback, useEffect, useRef } from "react";
import { useSubscriptionStore } from "./subscription-store";
export const useSubscription = (args, onResult, onError) => {
  const $ = _c(34);
  const addToStore = args.addToStore ?? true;
  const {
    upsert,
    remove
  } = useSubscriptionStore();
  const onResultRef = useRef(onResult);
  const onErrorRef = useRef(onError);
  let t0;
  let t1;
  if ($[0] !== onResult) {
    t0 = () => {
      onResultRef.current = onResult;
    };
    t1 = [onResult];
    $[0] = onResult;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== onError) {
    t2 = () => {
      onErrorRef.current = onError;
    };
    t3 = [onError];
    $[3] = onError;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== args) {
    t4 = getSubscriptionId(args);
    $[6] = args;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const subscriptionId = t4;
  let t5;
  let t6;
  if ($[8] !== addToStore || $[9] !== args.pause || $[10] !== subscriptionId || $[11] !== upsert) {
    t5 = () => {
      if (addToStore) {
        upsert(subscriptionId, {
          paused: args.pause
        });
      }
    };
    t6 = [subscriptionId, upsert, args.pause, addToStore];
    $[8] = addToStore;
    $[9] = args.pause;
    $[10] = subscriptionId;
    $[11] = upsert;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== addToStore || $[15] !== subscriptionId || $[16] !== upsert) {
    t7 = result => {
      onResultRef.current?.(result);
      if (addToStore) {
        upsert(subscriptionId, {
          hasError: false,
          paused: false
        });
      }
    };
    $[14] = addToStore;
    $[15] = subscriptionId;
    $[16] = upsert;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleResult = t7;
  let t8;
  if ($[18] !== addToStore || $[19] !== subscriptionId || $[20] !== upsert) {
    t8 = error => {
      onErrorRef.current?.(error);
      if (addToStore) {
        upsert(subscriptionId, {
          hasError: true,
          paused: false
        });
      }
    };
    $[18] = addToStore;
    $[19] = subscriptionId;
    $[20] = upsert;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handleError = t8;
  let t9;
  if ($[22] !== remove || $[23] !== subscriptionId) {
    t9 = () => {
      remove(subscriptionId);
    };
    $[22] = remove;
    $[23] = subscriptionId;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const handleUnsubscribe = t9;
  let t10;
  if ($[25] !== args.batchDelay || $[26] !== args.batchLeading || $[27] !== args.enableBatching || $[28] !== args.pauseOnInactivity || $[29] !== args.resetKey || $[30] !== handleError || $[31] !== handleResult || $[32] !== handleUnsubscribe) {
    t10 = {
      onResult: handleResult,
      onError: handleError,
      onUnsubscribe: handleUnsubscribe,
      pauseOnInactivity: args.pauseOnInactivity,
      resetKey: args.resetKey,
      enableBatching: args.enableBatching,
      batchDelay: args.batchDelay,
      batchLeading: args.batchLeading
    };
    $[25] = args.batchDelay;
    $[26] = args.batchLeading;
    $[27] = args.enableBatching;
    $[28] = args.pauseOnInactivity;
    $[29] = args.resetKey;
    $[30] = handleError;
    $[31] = handleResult;
    $[32] = handleUnsubscribe;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  useBaseSubscription(args, t10);
};